import { render, staticRenderFns } from "./ProspectRouteExpandableTable.vue?vue&type=template&id=14c1b107&scoped=true&"
import script from "./ProspectRouteExpandableTable.vue?vue&type=script&lang=js&"
export * from "./ProspectRouteExpandableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1b107",
  null
  
)

export default component.exports